import axios from 'axios';
import React, { useEffect, useState } from 'react';

export const Logo = ({ className, style, alt }) => {
  const [logoUrl, setLogoUrl] = useState('');

  useEffect(() => {
    const fetchLogoUrl = async () => {
      try {
        const response = await axios.get('home/GetLogo?OID=1'); // Replace with your actual endpoint
        console.log(response);
        setLogoUrl(response.data.logo); // Adjust based on your response structure
      } catch (error) {
        console.error('Error fetching logo URL:', error);
      }
    };

    fetchLogoUrl();
  }, []); // Empty dependency array ensures this runs only once

  if (!logoUrl) {
    return <div></div>; // Or any other loading indicator
  }

  return (
    <img
      // src={`${process.env.BARIN_URL}DM/ShowImg.aspx?file=${logoUrl}`}
      src={`https://localhost:56733/DM/ShowImg.aspx?file=${logoUrl}`}
      alt="Logo"
    />
  );
};
